import { Injectable } from '@angular/core';

import { CanDeactivateComponent } from '../interfaces/can-deactivate-component';
import { CanDeactivateService } from '../services/can-deactivate.service';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard  {

  constructor(private canDeactivateService: CanDeactivateService) { }

  canDeactivate(component: CanDeactivateComponent): Promise<boolean> {
    if (typeof component.canDeactivate === 'function' && !component.canDeactivate()) {
      const promise = this.canDeactivateService.canDeactivate(component.canDeactivateMessage, component.canDeactivateMessageTitle);
      promise.then(result => {
        component.handleDeactivationResult(result);
      });
      return promise;
    }
    return Promise.resolve(true);
  }
}
